import { render } from "./RouteLanding.vue?vue&type=template&id=49155246&scoped=true"
import script from "./RouteLanding.vue?vue&type=script&lang=js"
export * from "./RouteLanding.vue?vue&type=script&lang=js"

import "./RouteLanding.vue?vue&type=style&index=0&id=49155246&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49155246"]])

export default __exports__